import { useSnackbar } from 'notistack';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import Context from '../../../store/context';
import { deleteRequest } from '../../../api/api';
import { ConfirmModalWrapper, ConfirmTitle, ConfirmText, ButtonsWrapper, CustomButton } from './confirmModal-styles';
import { ActionsTypes } from '../../../store/reducer';
/**
 * модалка для удаления потребителя
 * @param {function} handleClose функция для закрытия модального окна
 * @param {number} consumerId id потребителя
 * @returns
 */
const ConsumersDeleteConfirm = ({ handleClose, consumerId }) => {
	const { state, dispatch, token } = useContext(Context);
	const { enqueueSnackbar } = useSnackbar();
	const { t } = useTranslation();

	const consumerDeleteHandler = async () => {
		//ожидание ответа от сервера
		const data = await deleteRequest(`${state.urls.BASE_URL}consumers/${consumerId}/`, token);
		/**
		 * если ответ положительный, то показываем дилоговое окно с успехом и диспатчим новый масив
		 * консьюмеров
		 */

		if (!data.isError) {
			enqueueSnackbar('Success delete', {
				variant: 'success',
			});
			dispatch({
				type: ActionsTypes.GET_CONSUMERS_FOR_SOURCE,
				payload: state.consumersForSource.filter((item) => item.id !== consumerId),
			});

			//иначе показываем ошибку и закрываем модальное окно
		} else {
			const errorKey = Object.keys(data.error.data)[0];
			if (errorKey) {
				enqueueSnackbar(data.error.data[errorKey], {
					variant: 'error',
				});
			} else {
				enqueueSnackbar('Server error', {
					variant: 'error',
				});
			}
		}
	};

	return (
		<ConfirmModalWrapper>
			<ConfirmTitle>{t('Are you sure?')}</ConfirmTitle>
			<ConfirmText>{t('This will delete this consumer')}</ConfirmText>
			<ButtonsWrapper>
				<CustomButton onClick={handleClose}>{t('Cancel')}</CustomButton>
				<CustomButton color="primary" onClick={consumerDeleteHandler}>
					Ok
				</CustomButton>
			</ButtonsWrapper>
		</ConfirmModalWrapper>
	);
};

export default ConsumersDeleteConfirm;
